module.exports = "<a href=\"#\" data-id=\"{{id}}\">{{title}}</a>\n"